import React from "react";
import { Link } from "react-router-dom";

const BreadcrumbTwo = ({
  title = "Shop Details",
  current = "",          // last breadcrumb item (product title)
  currentLink = null,    // optional
}) => {
  return (
    <div className="breadcrumb py-26 bg-color-one">
      <div className="container container-lg">
        <div className="breadcrumb-wrapper flex-between flex-wrap gap-16">
          <h6 className="mb-0">{title}</h6>

          <ul className="flex-align gap-8 flex-wrap">
            <li className="text-sm">
              <Link to="/" className="text-main-600 flex-align gap-8">
                <i className="ph ph-house" />
                Home
              </Link>
            </li>

            <li className="flex-align text-gray-500">
              <i className="ph ph-caret-right" />
            </li>

            <li className="text-sm">
              <Link to="/shop" className="text-main-600 flex-align gap-8">
                Shop
              </Link>
            </li>

            {current ? (
              <>
                <li className="flex-align text-gray-500">
                  <i className="ph ph-caret-right" />
                </li>

                <li className="text-sm text-neutral-600">
                  {currentLink ? (
                    <Link to={currentLink} className="text-main-600 flex-align gap-8">
                      {current}
                    </Link>
                  ) : (
                    current
                  )}
                </li>
              </>
            ) : null}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default BreadcrumbTwo;
